import React, { FC, useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { DrawerComponent, IFrameComponent } from "components";
import { MAIN_SITE } from "../../constants";
import { getLoginToOVOULink } from "utils/openLoginAsUserPage";

const ALLOWED_NAVIGATE_PATHS = new Set(["/profile-templates"]);

const getFrontV2Origin = (): string | null => {
  if (!MAIN_SITE) return null;
  try {
    return new URL(MAIN_SITE).origin;
  } catch {
    return null;
  }
};

const ProfileEmbedded: FC<{
  isOpen: boolean;
  onClose: () => void;
  profileId: string;
  teamId: string;
  roleId: number;
  link?: string;
}> = ({ isOpen, onClose, profileId, teamId, roleId, link }) => {
  const history = useHistory();
  const loginLink = useMemo(() => {
    return getLoginToOVOULink({
      profileID: profileId,
      teamID: teamId,
      roleId,
    });
  }, [profileId, teamId]);

  useEffect(() => {
    const expectedOrigin = getFrontV2Origin();
    const handleMessage = (event: MessageEvent<any>) => {
      if (expectedOrigin && event.origin !== expectedOrigin) return;
      if (!event.data || typeof event.data !== "object") return;
      if (event.data.close) {
        onClose();
      }
      if (
        typeof event.data.navigateTo === "string" &&
        ALLOWED_NAVIGATE_PATHS.has(event.data.navigateTo)
      ) {
        history.push(event.data.navigateTo);
      }
    };
    window.addEventListener("message", handleMessage, false);
    return () => {
      window.removeEventListener("message", handleMessage, false);
    };
  }, [history, onClose]);
  return (
    <DrawerComponent isOpen={isOpen} onClose={onClose}>
      <IFrameComponent
        srcLink={link ? link : loginLink}
        height="100%"
        width="100%"
      />
    </DrawerComponent>
  );
};

export default ProfileEmbedded;
